export const bookStatus = {
  NONE: 'NONE',
  WAITING: 'WAITING',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
};

export const categoryStatus = {
  NONE: 'NONE',
  WAITING: 'WAITING',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
};

export const seriesStatus = {
  NONE: 'NONE',
  WAITING: 'WAITING',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
};

export const authorStatus = {
  NONE: 'NONE',
  WAITING: 'WAITING',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
};

export const userStatus = {
  NONE: 'NONE',
  WAITING: 'WAITING',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  FAILURE_USERNAME: 'FAILURE_USERNAME',
};

export const basketStatus = {
  NONE: 'NONE',
  WAITING: 'WAITING',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  FAILURE_MAX_BOOK: 'FAILURE_MAX_BOOK',
};
